(function () {
  "use strict";

  const SUGGESTIONS = [
    "モバイルバッテリー",
    "充電器",
    "ワイヤレス充電器",
    "ケーブル",
    "USBハブ",
    "アダプタ",
    "ポータブル電源",
    "ソーラーパネル",
    "イヤホン",
    "ワイヤレスイヤホン",
    "オープンイヤー",
    "ヘッドホン",
    "スピーカー",
    "掃除機",
    "ロボット掃除機",
    "プロジェクター",
    "セキュリティカメラ",
    "体重計",
    "Webカメラ",
    "3Dプリンター",
    "ドッキングステーション",
    "MagSafe",
    "iPhone ケース",
    "ガラスフィルム",
    "USB-C",
    "Lightning",
    "HDMI",
    "Soundcore",
    "Eufy",
    "Nebula",
    "Anker Power Bank",
    "Anker Prime",
    "Anker Solix",
    "AnkerMake",
    "Liberty",
    "Space One",
    "AeroFit",
    "防災",
    "キャンプ",
    "在宅ワーク",
    "車載",
    "旅行",
  ];

  const POPULAR_KEYWORDS = [
    "モバイルバッテリー",
    "ワイヤレスイヤホン",
    "ロボット掃除機",
    "充電器",
    "プロジェクター",
    "防災",
  ];

  const loadTrendingProducts = () => {
    try {
      const el = document.getElementById("search-trending-products");
      if (!el) return [];
      return JSON.parse(el.textContent).filter(Boolean);
    } catch (_) {
      return [];
    }
  };

  let activeIndex = -1;

  const normalize = (str) => str.toLowerCase().replace(/[\s\u3000]/g, "");

  const toHiragana = (str) =>
    str.replace(/[\u30A1-\u30F6]/g, (ch) =>
      String.fromCharCode(ch.charCodeAt(0) - 0x60)
    );

  const match = (query) => {
    if (!query || query.length < 1) return [];
    const nq = normalize(toHiragana(query));
    return SUGGESTIONS.filter((s) => {
      const ns = normalize(toHiragana(s));
      return ns.includes(nq);
    }).slice(0, 6);
  };

  const highlight = (text, query) => {
    const nq = normalize(toHiragana(query));
    const nt = normalize(toHiragana(text));
    const idx = nt.indexOf(nq);
    if (idx === -1) return text;
    const before = text.slice(0, idx);
    const matched = text.slice(idx, idx + query.length);
    const after = text.slice(idx + query.length);
    return `${before}<mark>${matched}</mark>${after}`;
  };

  const render = (listEl, results, query) => {
    activeIndex = -1;
    if (results.length === 0) {
      listEl.innerHTML = "";
      listEl.classList.remove("is-open");
      return;
    }
    listEl.innerHTML = results
      .map(
        (r, i) =>
          `<li class="v2-search-suggest-item" role="option" data-index="${i}" data-value="${r}">${highlight(r, query)}</li>`
      )
      .join("");
    listEl.classList.add("is-open");
  };

  const renderPopular = (listEl) => {
    activeIndex = -1;
    const trending = loadTrendingProducts();
    let html = "";
    let idx = 0;

    if (trending.length > 0) {
      html += '<li class="v2-search-suggest-label">今売れている製品</li>';
      trending.forEach((r) => {
        html += `<li class="v2-search-suggest-item" role="option" data-index="${idx}" data-value="${r}">${r}</li>`;
        idx++;
      });
    }

    html += '<li class="v2-search-suggest-label">人気のキーワード</li>';
    POPULAR_KEYWORDS.forEach((r) => {
      html += `<li class="v2-search-suggest-item" role="option" data-index="${idx}" data-value="${r}">${r}</li>`;
      idx++;
    });

    listEl.innerHTML = html;
    listEl.classList.add("is-open");
  };

  const close = (listEl) => {
    listEl.innerHTML = "";
    listEl.classList.remove("is-open");
    activeIndex = -1;
  };

  const select = (input, listEl, value) => {
    input.value = value;
    close(listEl);
    input.closest("form").submit();
  };

  const updateActive = (listEl) => {
    const items = listEl.querySelectorAll(".v2-search-suggest-item");
    items.forEach((item, i) => {
      item.classList.toggle("is-active", i === activeIndex);
    });
  };

  const initForm = (form) => {
    const input = form.querySelector(".v2-search-input");
    const listEl = form.querySelector(".v2-search-suggest");
    if (!input || !listEl) return;

    input.addEventListener("input", () => {
      const q = input.value.trim();
      if (q) {
        const results = match(q);
        render(listEl, results, q);
      } else {
        close(listEl);
      }
    });

    input.addEventListener("keydown", (e) => {
      if (!listEl.classList.contains("is-open")) return;
      const items = listEl.querySelectorAll(".v2-search-suggest-item");
      const count = items.length;
      if (count === 0) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        activeIndex = (activeIndex + 1) % count;
        updateActive(listEl);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        activeIndex = (activeIndex - 1 + count) % count;
        updateActive(listEl);
      } else if (e.key === "Enter" && activeIndex >= 0) {
        e.preventDefault();
        select(input, listEl, items[activeIndex].dataset.value);
      } else if (e.key === "Escape") {
        close(listEl);
      }
    });

    let pendingValue = null;

    listEl.addEventListener("touchstart", (e) => {
      const item = e.target.closest(".v2-search-suggest-item");
      if (item) {
        pendingValue = item.dataset.value;
      }
    }, { passive: true });

    listEl.addEventListener("touchend", (e) => {
      if (pendingValue) {
        e.preventDefault();
        const value = pendingValue;
        pendingValue = null;
        select(input, listEl, value);
      }
    });

    listEl.addEventListener("pointerdown", (e) => {
      const item = e.target.closest(".v2-search-suggest-item");
      if (item) {
        e.preventDefault();
      }
    });

    listEl.addEventListener("click", (e) => {
      const item = e.target.closest(".v2-search-suggest-item");
      if (item) {
        e.preventDefault();
        select(input, listEl, item.dataset.value);
      }
    });

    input.addEventListener("blur", () => {
      setTimeout(() => {
        if (!pendingValue) close(listEl);
      }, 300);
    });

    input.addEventListener("focus", () => {
      const q = input.value.trim();
      if (q) {
        const results = match(q);
        render(listEl, results, q);
      }
    });
  };

  const init = () => {
    document.querySelectorAll(".v2-form-hd-search").forEach(initForm);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
